/**
 * Form Input Fix for No-Ajax Variants
 *
 * This script fixes issues with form inputs not being properly updated when variants are changed
 * It works with the existing no-ajax-variants.js file to ensure proper variant selection.
 */

(function() {
  
  // Global state to prevent loops
  let isUpdatingForms = false;
  let lastUpdatedVariantId = null;
  let updateCount = 0;
  let lastUpdateTime = 0;
  
  // Loop detection threshold
  const MAX_UPDATES_PER_SECOND = 5;
  const LOOP_DETECTION_WINDOW_MS = 1000;
  
  // Store the current variant
  let currentVariant = null;
  
  function init() {    
    // Wait for the document to be ready if it's not already
    if (document.readyState !== 'complete' && document.readyState !== 'interactive') {
      document.addEventListener('DOMContentLoaded', patchFormInputs);
    } else {
      patchFormInputs();
    }
    
    // Listen for variant:input:updated event
    document.addEventListener('variant:input:updated', (e) => {
      // Skip if we already recently updated this variant to prevent loops
      if (e._generatedByFormInputFix) {
        return;
      }
      
      if (e.detail && e.detail.variant) {        
        // Short timeout to allow other handlers to complete
        setTimeout(() => {
          updateAllFormInputs(e.detail.variant);
        }, 100);
      }
    });
    
    // Add a global method for forcing updates
    window.forceUpdateFormInputs = function(variantId) {
      const noAjaxVariants = document.querySelector('no-ajax-variants');
      if (!noAjaxVariants || !noAjaxVariants.variantData) {
        console.error('Cannot force update: No variant data available');
        return false;
      }
      
      const variant = noAjaxVariants.variantData.find(v => v.id.toString() === variantId.toString());
      if (!variant) {
        console.error(`Cannot force update: Variant ${variantId} not found`);
        return false;
      }
      
      // Reset global state
      isUpdatingForms = false;
      updateAllFormInputs(variant);
      return true;
    };
  }
  
  function patchFormInputs() {
    // Find product forms
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    
    productForms.forEach((form, index) => {
      const idInput = form.querySelector('input[name="id"]');
      
      // Add listeners to variant radios and selects specifically inside this form
      form.querySelectorAll('input[type="radio"], select').forEach(input => {
        // We'll let the standard Shopify variant selects handle their own logic
      });
    });
    
    // Patch the hidden variant ID inputs to track changes
    const variantIdInputs = document.querySelectorAll('input[name="id"]');
    
    variantIdInputs.forEach((input, index) => {
      
      // Create a MutationObserver to watch for value changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            const newValue = input.value;
          }
        });
      });
      
      // Start observing
      observer.observe(input, { attributes: true });
    });
    
    // Also find and patch the updateFormInput on no-ajax-variants if it exists
    setTimeout(() => {
      const noAjaxVariants = document.querySelector('no-ajax-variants');
      if (noAjaxVariants) {
        patchNoAjaxVariants(noAjaxVariants);
        
        // Get current variant from no-ajax-variants
        if (noAjaxVariants.currentVariant) {
          currentVariant = noAjaxVariants.currentVariant;
          
          // Initialize with current variant data
          setTimeout(() => {
            updateAllFormInputs(currentVariant);
          }, 100);
        }
      }
      
    }, 100);
  }
  
  function patchNoAjaxVariants(noAjaxInstance) {
    // Don't patch if already patched
    if (noAjaxInstance._formInputFixPatched) {
      return;
    }
    
    // Save the original updateFormInput method
    const originalUpdateFormInput = noAjaxInstance.updateFormInput;
    
    // Replace with our own version
    noAjaxInstance.updateFormInput = function(variant) {
      
      // Don't proceed if no variant
      if (!variant) {
        return;
      }
      
      // Save the current variant
      currentVariant = variant;
      
      // Call the original method
      return originalUpdateFormInput.call(this, variant);
    };
    
    // Mark as patched
    noAjaxInstance._formInputFixPatched = true;
    
  }
  
  function updateAllFormInputs(variant) {
    // Don't update if we're already updating to prevent loops
    if (isUpdatingForms) {
      return;
    }
    
    // Track the last updated variant ID to detect loops
    if (lastUpdatedVariantId === variant.id) {
      const now = Date.now();
      if (now - lastUpdateTime < LOOP_DETECTION_WINDOW_MS) {
        updateCount++;
        if (updateCount > MAX_UPDATES_PER_SECOND) {
          return;
        }
      } else {
        // Reset counter for a new time window
        updateCount = 1;
      }
      lastUpdateTime = now;
    } else {
      // New variant, reset counter
      updateCount = 1;
      lastUpdatedVariantId = variant.id;
      lastUpdateTime = Date.now();
    }
    
    // Set updating flag
    isUpdatingForms = true;
    
    try {
      
      // Update the hidden form inputs with the variant ID
      
      formInputs.forEach((input, index) => {
        const oldValue = input.value;
        if (oldValue !== variant.id.toString()) {
          input.value = variant.id;
          
          
          // Dispatch change event with special flag
          const event = new Event('change', { bubbles: true });
          // CRUCIAL: Mark this event to prevent loops
          event._generatedByFormInputFix = true;
          input.dispatchEvent(event);
        }
      });
      
      // Try to update all option inputs
      const options = variant.options || [];
      
      options.forEach((optionValue, index) => {
        const position = index + 1; // Options are 1-indexed
        
        // Try different name formats for compatibility with different themes
        const optionNameFormats = [
          `options[option${position}]`,
          `options[Option ${position}]`,
          `option${position}`,
          `Option ${position}`
        ];
        
        let updated = false;
        
        optionNameFormats.forEach(nameFormat => {
          
          // Try to find radio buttons for this option
          const radioButtons = document.querySelectorAll(`input[type="radio"][name="${nameFormat}"]`);
          if (radioButtons.length > 0) {
            radioButtons.forEach(radio => {
              if (radio.value === optionValue) {
                const wasChecked = radio.checked;
                if (!wasChecked) {
                  radio.checked = true;
                  
                  // Only dispatch event if state changed and we didn't just update it
                  if (!radio._justUpdatedByFormInputFix) {
                    const event = new Event('change', { bubbles: true });
                    event._generatedByFormInputFix = true;
                    radio.dispatchEvent(event);
                  }
                  updated = true;
                  radio._justUpdatedByFormInputFix = true;
                  
                  // Clear flag after a short delay
                  setTimeout(() => {
                    radio._justUpdatedByFormInputFix = false;
                  }, 100);
                } else {
                  updated = true;
                }
              }
            });
          }
          
          // Try to find select elements
          if (!updated) {
            const selectElements = document.querySelectorAll(`select[name="${nameFormat}"]`);
            if (selectElements.length > 0) {
              selectElements.forEach(select => {
                const option = Array.from(select.options).find(opt => opt.value === optionValue);
                if (option) {
                  const oldValue = select.value;
                  if (oldValue !== optionValue) {
                    select.value = optionValue;
                    option.selected = true;
                    
                    // Only dispatch if we didn't just update it
                    if (!select._justUpdatedByFormInputFix) {
                      const event = new Event('change', { bubbles: true });
                      event._generatedByFormInputFix = true;
                      select.dispatchEvent(event);
                    }
                    updated = true;
                    select._justUpdatedByFormInputFix = true;
                    
                    // Clear flag after a short delay
                    setTimeout(() => {
                      select._justUpdatedByFormInputFix = false;
                    }, 100);
                  } else {
                    updated = true;
                  }
                }
              });
            }
          }
        });
        
      });
      
      // Handle bundle options separately
      const bundleOptions = document.querySelector('bundle-options');
      if (bundleOptions) {
        const bundleRadios = document.querySelectorAll('.bundle-option input[type="radio"]');
        
        let bundleUpdated = false;
        bundleRadios.forEach((radio, index) => {          
          // Check if this radio matches any of the variant options
          const matches = options.some(option => option === radio.value);
          
          if (matches) {
            const wasChecked = radio.checked;
            if (!wasChecked) {
              radio.checked = true;
              
              // Only dispatch if it wasn't just updated AND state changed
              if (!radio._justUpdatedByFormInputFix) {
                // Create and dispatch a change event, but mark it to prevent loops
                const event = new Event('change', { bubbles: true });
                event._generatedByFormInputFix = true;
                radio.dispatchEvent(event);
              }
              bundleUpdated = true;
              radio._justUpdatedByFormInputFix = true;
              
              // Clear flag after a short delay
              setTimeout(() => {
                radio._justUpdatedByFormInputFix = false;
              }, 100);
            } else {
              bundleUpdated = true;
            }
          }
        });
        
        // Update the UI directly instead of triggering events
        if (typeof bundleOptions.updateUI === 'function') {
          try {
            // Add a special flag to prevent bundle-options from dispatching events
            bundleOptions._updatingFromFormInputFix = true;
            bundleOptions.updateUI();
            // Clear the flag
            setTimeout(() => {
              bundleOptions._updatingFromFormInputFix = false;
            }, 100);
          } catch (e) {
            console.error(`  Error calling bundleOptions.updateUI():`, e);
          }
        }
      }
      
      // Notify other components safely - don't use events for this to avoid loops
      // Use a custom event for a one-time notification
      if (typeof window.dispatchEvent === 'function') {
        // Only dispatch this event if it wasn't triggered by the same event
        const customEvent = new CustomEvent('form-input-fix:updated', {
          bubbles: true,
          detail: { variant }
        });
        customEvent._generatedByFormInputFix = true;
        document.dispatchEvent(customEvent);
      }
    } catch (e) {
    } finally {
      // Always clear the updating flag after a short delay
      setTimeout(() => {
        isUpdatingForms = false;
      }, 100);
    }
  }
  
  // Patch the change event handler for bundle option radios to prevent loops
  document.addEventListener('change', function(e) {
    // Check if this is a bundle radio button change
    if (e.target && e.target.type === 'radio' && e.target.closest('.bundle-option')) {
      
      // Skip if this event was generated by our code or other components
      if (e._generatedByFormInputFix || e._generatedByNoAjaxVariants || e._generatedByBundleOptions) {
        e.stopPropagation();
        return;
      }
      
      // Skip if we just updated this element to prevent loops
      if (e.target._justUpdatedByFormInputFix) {
        e.stopPropagation();
        return;
      }
      
    }
  }, true); // Use capture phase to intercept before other handlers
  
  // Initialize the script
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})(); 